import Catalogue from './Catalogue';
export default Catalogue;
